// Gallery API service - always use relative URLs for correct server routing
const API_URL = '';

export const galleryApi = {
  // Get all gallery items with optional filters
  async getItems({ category = null, search = null, limit = 200, skip = 0 } = {}) {
    const params = new URLSearchParams();
    if (category && category !== 'all') params.append('category', category);
    if (search) params.append('search', search);
    if (limit) params.append('limit', limit.toString());
    if (skip) params.append('skip', skip.toString());
    
    const response = await fetch(`${API_URL}/api/gallery?${params}`);
    if (!response.ok) throw new Error('Failed to fetch gallery items');
    return response.json();
  },

  // Get featured items for homepage
  async getFeaturedItems(limit = 3) {
    const response = await fetch(`${API_URL}/api/gallery/featured?limit=${limit}`);
    if (!response.ok) throw new Error('Failed to fetch featured items');
    return response.json();
  },

  // Get categories with counts
  async getCategories() {
    const response = await fetch(`${API_URL}/api/gallery/categories`);
    if (!response.ok) throw new Error('Failed to fetch categories');
    return response.json();
  },

  // Get a single item by ID
  async getItem(id) {
    const response = await fetch(`${API_URL}/api/gallery/${id}`);
    if (!response.ok) throw new Error('Failed to fetch item');
    return response.json();
  },

  // Get gallery statistics
  async getStats() {
    const response = await fetch(`${API_URL}/api/gallery/stats/summary`);
    if (!response.ok) throw new Error('Failed to fetch stats');
    return response.json();
  }
};

export default galleryApi;
